import Shower from './ShowerContainer';

export default Shower;
